import { render, staticRenderFns } from "./LearningRequestConf.vue?vue&type=template&id=8747bca2"
import script from "./LearningRequestConf.vue?vue&type=script&lang=js"
export * from "./LearningRequestConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports